import { useEffect } from "react"
import CustomTooltip from "../Buttons/CustomTooltip"

const ViewModelForDbMigration = ({
  viewshow,
  viewsetShow,
  jobId,
  jobProgressData,
  fetchJobProgress,
  progressLoading,
  progressError,
}) => {
  useEffect(() => {
    if (viewshow && jobId) {
     
    }
  }, [viewshow, jobId])

  const handleviewClose = () => viewsetShow(false)

  const truncateText = (text, maxLength) => {
    if (!text) return "N/A"

    const isTruncated = text.length > maxLength
    const truncated = isTruncated ? `${text.substring(0, maxLength)}...` : text

    return isTruncated ? (
      <CustomTooltip content={text} placement="right" fallbackPlacements={["top"]}>
        <span className="truncated-text" style={{ cursor: "pointer" }}>
          {truncated}
        </span>
      </CustomTooltip>
    ) : (
      <span>{text}</span>
    )
  }

  if (!viewshow) return null

  return (
    <div className="right-bar3 p-3">
      <style>
        {`
          /* Fix for DB migration view tooltip positioning */
          .right-bar3 .custom-tooltip {
            z-index: 10000 !important;
            position: fixed !important;
          }
          
          .custom-tooltip[data-popper-placement^='left'] > .react-tooltip-arrow {
            border-left-color: #e0b8ff !important;
          }
          
          /* New styles from the updated design */
          .custom-accordion .card {
            border-radius: 8px;
          }
        
          
         
          
      
        `}
      </style>
      <div data-simplebar>
        <div className="header-fixed d-flex justify-content-between align-items-center">
          <h6 className="mb-0 fw-medium textfontsizehead" style={{ fontSize: "14px" }}>
            View Job Summary
          </h6>
          <div style={{ position: "relative", zIndex: 10 }}>
            <CustomTooltip
              content="Close"
              placement="left"
              fallbackPlacements={["top-end", "top"]}
              offset={[-10, 0]}
              delayShow={200}
            >
              <i
                onClick={handleviewClose}
                className="mdi mdi-close close-trace cursor-pointer right-bar-toggle3 iconColor"
              />
            </CustomTooltip>
          </div>
        </div>

        {progressLoading ? (
          <div className="container mt-4 ps-0 ms-0" style={{ height: "100vh" }}>
            <div className="textfontsizehead fw-bold pt-2" style={{ fontSize: "16px" }}>
              <span
                className="loadingStyle"
                style={{
                  height: "24px",
                  width: "60%",
                  display: "inline-block",
                }}
              ></span>
            </div>

            <div className="accordion" id="accordionExample">
              {[...Array(3)].map((_, i) => (
                <div className="card mb-1 shadow-none ans-float-box flot-body" key={i}>
                  <div className="flot-head">
                    <div className="loadingStyle" style={{ height: "20px", width: "40%" }}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : progressError ? (
          <div className="alert alert-danger mt-3">{progressError}</div>
        ) : !jobProgressData ? (
          <div className="alert alert-info mt-3">No job data available</div>
        ) : (
          <div className="container mt-2 ps-0 ms-0" style={{ height: "100vh" }}>
            <div className="textfontsizeone fw-bold pt-2" style={{ fontSize: "16px" }}>
              Job Name : {truncateText(jobProgressData.jobName, 10)} ID : {jobProgressData.jobId}
            </div>
            
            <div className="row mt-4 pb-2">
              {/* Job Details Accordion */}
              <div className="col-12 mb-2">
                <div id="accordion" className="custom-accordion">
                  <div className="card mb-1 shadow-none ans-float-box flot-body">
                    <a href="#collapseOne" className="text-reset" data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapseOne">
                      <div className="flot-head" id="headingOne">
                        <h6 className="m-0 font-size-12 fw-bold font-family-dmsans" style={{ color: "#354258", fontSize: "13px" }}>
                          <span className="me-2"><i className="fa-solid fa-circle-info"></i></span>
                          Job Details
                          <i className="mdi mdi-minus float-end accor-plus-icon" style={{ color: "#354258" }}></i>
                        </h6>
                      </div>
                    </a>

                    <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">
                      <div className="flot-body" data-simplebar>
                        <div className="row">
                          <div className="col-6">
                            <div className="flot-body-item">
                              <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                <span style={{ color: "#494949" }} className="me-1 fw-medium">Job Name:</span> 
                                {jobProgressData.jobName || "N/A"}
                              </p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="flot-body-item">
                              <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                <span style={{ color: "#494949" }} className="me-1 fw-medium">Tables Failed:</span>
                                {jobProgressData.tablesFailed || 0}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6">
                            <div className="flot-body-item">
                              <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                <span style={{ color: "#494949" }} className="me-1 fw-medium">Total Table Count:</span>
                                {jobProgressData.totalTableCount || 0}
                              </p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="flot-body-item">
                              <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                <span style={{ color: "#494949" }} className="me-1 fw-medium">Job Progress:</span>
                                {jobProgressData.jobProgress || 0}%
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6">
                            <div className="flot-body-item">
                              <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                <span style={{ color: "#494949" }} className="me-1 fw-medium">Tables In Progress:</span>
                                {jobProgressData.tablesInProgress || 0}
                              </p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="flot-body-item">
                              <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                <span style={{ color: "#494949" }} className="me-1 fw-medium">Total Schema Count:</span>
                                {jobProgressData.totalSchemaCount || 0}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6">
                            <div className="flot-body-item">
                              <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                <span style={{ color: "#494949" }} className="me-1 fw-medium">Tables Completed:</span>
                                {jobProgressData.tablesCompleted || 0}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Schema Details Accordion */}
              <div className="col-12 mb-2">
                <div id="accordion" className="custom-accordion">
                  <div className="card mb-1 shadow-none ans-float-box flot-body">
                    <a href="#collapseThree" className="text-reset" data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapseOne">
                      <div className="flot-head" id="headingOne">
                        <h6 className="m-0 font-size-12 fw-bold font-family-dmsans" style={{ color: "#354258" }}>
                          <span className="me-2"><i className="fa-solid fa-diagram-project"></i></span>
                          Schema details
                          <i className="mdi mdi-minus float-end accor-plus-icon" style={{ color: "#354258" }}></i>
                        </h6>
                      </div>
                    </a>

                    <div id="collapseThree" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">
                      <div className="flot-body" data-simplebar>
                        <div className="row">
                          <div className="col-6">
                            <div className="flot-body-item">
                              <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                <span style={{ color: "#494949" }} className="me-1 fw-medium">Schemas Completed:</span>
                                {jobProgressData.schemasCompleted || 0}
                              </p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="flot-body-item">
                              <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                <span style={{ color: "#494949" }} className="me-1 fw-medium">Total Tables:</span>
                                {jobProgressData.totalTableCount || 0}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6">
                            <div className="flot-body-item">
                              <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                <span style={{ color: "#494949" }} className="me-1 fw-medium">Schemas In Progress:</span>
                                {jobProgressData.schemasInProgress || 0}
                              </p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="flot-body-item">
                              <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                <span style={{ color: "#494949" }} className="me-1 fw-medium">Completed Tables:</span>
                                {jobProgressData.tablesCompleted || 0}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6">
                            <div className="flot-body-item">
                              <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                <span style={{ color: "#494949" }} className="me-1 fw-medium">Schema Status:</span>
                                {jobProgressData.schemasInProgress > 0 ? "In Progress" : "Completed"}
                              </p>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="flot-body-item">
                              <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                <span style={{ color: "#494949" }} className="me-1 fw-medium">Schema Progress Percent:</span>
                                {jobProgressData.progressBar?.tableProgressPercent || 0}%
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Individual Schema Accordions */}
              {Object.entries(jobProgressData.schemaDetails || {}).map(([schemaName, schemaDetails], index) => (
                <div className="col-12 mb-2" key={schemaName}>
                  <div id="accordion" className="custom-accordion">
                    <div className="card mb-1 shadow-none ans-float-box flot-body">
                      <a href={`#collapseSchema${index}`} className="text-reset" data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapseOne">
                        <div className="flot-head" id="headingOne">
                          <h6 className="m-0 font-size-12 fw-bold font-family-dmsans" style={{ color: "#354258" }}>
                            <span className="me-2"><i className="fa-solid fa-database"></i></span>
                            {schemaName}
                            <i className="mdi mdi-minus float-end accor-plus-icon" style={{ color: "#354258" }}></i>
                          </h6>
                        </div>
                      </a>

                      <div id={`collapseSchema${index}`} className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">
                        <div className="flot-body" data-simplebar>
                          <div className="row">
                            <div className="col-6">
                              <div className="flot-body-item">
                                <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                  <span style={{ color: "#494949" }} className="me-1 fw-medium">Schema Status:</span>
                                  {schemaDetails.schemaStatus || "N/A"}
                                </p>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="flot-body-item">
                                <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                  <span style={{ color: "#494949" }} className="me-1 fw-medium">Completed Tables:</span>
                                  {schemaDetails.completedTables || 0}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-6">
                              <div className="flot-body-item">
                                <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                  <span style={{ color: "#494949" }} className="me-1 fw-medium">Total Tables:</span>
                                  {schemaDetails.totalTables || 0}
                                </p>
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="flot-body-item">
                                <p className="mb-0 d-flex" style={{ fontSize: "12px", color: "#818283" }}>
                                  <span style={{ color: "#494949" }} className="me-1 fw-medium">Schema Progress Percent:</span>
                                  {schemaDetails.schemaProgressPercent || 0}%
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="fixed-close-button">
        <button onClick={handleviewClose} className="btn btn-closebtn custom-button">
          Close
        </button>
      </div>
    </div>
  )
}

export default ViewModelForDbMigration